// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UpV4FBgkKcUlNQ1d2d5gX{display:none}@media (min-width:992px){.UpV4FBgkKcUlNQ1d2d5gX{display:block;bottom:0;right:0;float:right;margin:0 .8rem .8rem 0;z-index:2000!important;position:fixed}}._1LnlYvvhDTdTfm7JASaYyy{padding:1.6rem;background-color:#fff;border-radius:.6rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badgeWrapper": "UpV4FBgkKcUlNQ1d2d5gX",
	"widget": "_1LnlYvvhDTdTfm7JASaYyy"
};
module.exports = ___CSS_LOADER_EXPORT___;
